import React, { useState, useEffect } from 'react'
import './FailedReconciliation.scss'
import { useParams } from 'react-router-dom';
import { Table, Modal, Button, Form, FormControl } from 'react-bootstrap';
import { saveAs } from 'file-saver';
import Header from '../Header';
import SideBar from '../SideBar';
import ReconcileFailedPaymentModal from './ReconcileFailedPaymentModal';

// auth imports
import jwt_decode from "jwt-decode";
import { serverUrl } from "../../../serverUrl";
import { toast } from "react-toastify";


function FailedReconciliation() {
    // getting the id and finding the apparment details
    const { id } = useParams();
    const isAllProperties = id === 'all';
    // sidebar and header functions
    const [showSidebar, setShowSidebar] = useState(true);
    function toggleSidebar() {
        setShowSidebar(!showSidebar);
    }
    // houses within the apartment
    const [ctobTransactions, setCtobTransactions] = useState([])

    // get the houses and the tenants that are within that house
    const accessToken = localStorage.getItem("authTokens");
    // get the access token
    const parsedTokens = JSON.parse(accessToken);
    const access = parsedTokens.access;


    // headers access token
    const config = {
        headers: { Authorization: `Bearer ${access}` }
    }
    // decoding the token so that i can get the user id
    const decodedToken = jwt_decode(accessToken);
    const userId = decodedToken.user_id;

    const [landlordApartment, setLandlordApartment] = useState([])

    const [shortCodeApartment, setShortCode] = useState('')
    // from the localstorage get the logged in user and get the details of the selected apartment with the houses in the apartments and the tenants 
    useEffect(() => {


        // get the landlord details that are linked to the user
        serverUrl.get(`/landlord/landlord/?user_id=${userId}`, config)
            .then((res) => {
                // get the landlord Id
                const landlordIds = res.data.results.map((landlord) => landlord.id);

                // get the failed transactions
                const fetchFailedTransactions = serverUrl.get(`/landlord/get-failed-reconciliation/?landlord_id=${landlordIds}&page_size=500`, config);

                if (isAllProperties) {
                    fetchFailedTransactions
                        .then((failedTransactionsRes) => {
                            setCtobTransactions(failedTransactionsRes.data.results);
                            setShortCode('');
                        })
                        .catch((error) => {
                            console.log(error);
                        });
                } else {
                    const fetchMpesaCredentials = serverUrl.get(`/landlord/apartment-mpesa-credentials/?apartment=${id}`, config);

                    Promise.all([fetchFailedTransactions, fetchMpesaCredentials])
                        .then(([failedTransactionsRes, mpesaCredentialsRes]) => {
                            const dataCtobFailed = failedTransactionsRes.data.results;
                            const shortCodeApartment = mpesaCredentialsRes.data.results?.[0]?.short_code;

                            if (!shortCodeApartment) {
                                setCtobTransactions([]);
                                setShortCode('');
                                return;
                            }

                            const filteredTransactions = dataCtobFailed.filter(transaction => {
                                return transaction.business_shortcode === shortCodeApartment.toString();
                            });

                            setCtobTransactions(filteredTransactions);
                            setShortCode(shortCodeApartment.toString());
                        })
                        .catch(error => {
                            console.log(error);
                        });
                }
                // end of working code



                // using the landlord id get the apartments linked to the landlord
                const landlordApartmentPromises = landlordIds.map((landlordId) => {
                    return serverUrl.get(`/landlord/landlord-apartment_name/?landlord_id=${landlordId}`, config)
                        .then((res) => res.data.results)
                        .catch((error) => {
                            console.log(error);
                            return [];
                        });
                });

                Promise.all(landlordApartmentPromises)
                    .then((results) => {
                        // i am merging the sub-arrays into a new array
                        const apartments = results.flat();
                        setLandlordApartment(apartments);
                        // getting the houses in the apartment
                        const houseCountPromises = apartments.map((apartment) => {
                            return serverUrl.get(`/landlord/house/?apartment_id=${apartment.id}`, config)
                                .then((res) => ({ apartmentId: apartment.id, houses: res.data.results }))
                                .catch((error) => {
                                    console.log(error);
                                    return { apartmentId: apartment.id, houses: [] };
                                });
                        });

                    })
                    .catch((error) => {
                        console.log(error);

                    });
            })
            .catch((error) => {
                console.log(error);
            });
    }, []);


    // searching function and sorting functionalities
    const [sortType, setSortType] = useState("transcation_time");
    const [sortOrder, setSortOrder] = useState("asc");
    const [searchQuery, setSearchQuery] = useState("");
    const [selectedRow, setSelectedRow] = useState(null);

    const handleSort = (sortField) => {
        setSortType(sortField);
        setSortOrder(sortOrder === "asc" ? "desc" : "asc");
    };

    const handleSearch = (event) => {
        setSearchQuery(event.target.value);
        setCurrentPage(0);
        setSelectedRow(null); // Reset selected row when user starts a new search
    };

    const sortedData = [...ctobTransactions].sort((a, b) => {
        const rawValueA = a[sortType] ?? "";
        const rawValueB = b[sortType] ?? "";
        const sortValueA = typeof rawValueA === "string" ? rawValueA.toLowerCase() : rawValueA;
        const sortValueB = typeof rawValueB === "string" ? rawValueB.toLowerCase() : rawValueB;
        if (sortOrder === "asc") {
            return sortValueA > sortValueB ? 1 : -1;
        } else {
            return sortValueA < sortValueB ? 1 : -1;
        }
    });

    const filteredData = sortedData.filter((item) => {
        const searchableFields = Object.values(item).join(" ").toLowerCase();
        return searchableFields.includes(searchQuery.toLowerCase());
    });

    // design the table to display 10 each per table
    const [currentPage, setCurrentPage] = useState(0);
    const [selectedTransactionIds, setSelectedTransactionIds] = useState([]);
    const [isDeleting, setIsDeleting] = useState(false);
    const itemsPerPage = 10;

    const totalPages = Math.ceil(filteredData.length / itemsPerPage);
    const startIndex = currentPage * itemsPerPage;
    const endIndex = currentPage === totalPages - 1 ? filteredData.length : startIndex + itemsPerPage;
    const displayedItems = filteredData.slice(startIndex, endIndex);
    const filteredTransactionIds = filteredData.map((transaction) => transaction.id);
    const areAllFilteredTransactionsSelected = filteredTransactionIds.length > 0
        && filteredTransactionIds.every((transactionId) => selectedTransactionIds.includes(transactionId));

    const handleSelectAll = (event) => {
        if (event.target.checked) {
            setSelectedTransactionIds((currentIds) => [
                ...new Set([...currentIds, ...filteredTransactionIds]),
            ]);
            return;
        }

        const filteredIdSet = new Set(filteredTransactionIds);
        setSelectedTransactionIds((currentIds) => (
            currentIds.filter((transactionId) => !filteredIdSet.has(transactionId))
        ));
    };

    const handleSelectTransaction = (transactionId) => {
        setSelectedTransactionIds((currentIds) => (
            currentIds.includes(transactionId)
                ? currentIds.filter((selectedId) => selectedId !== transactionId)
                : [...currentIds, transactionId]
        ));
    };

    const handlePrevPage = () => {
        setCurrentPage(currentPage - 1);
    };

    const handleNextPage = () => {
        setCurrentPage(currentPage + 1);
    };

    // modal for adding new transaction
    const [showModal, setShowModal] = useState(false)

    const handleOpenModal = () => {
        setShowModal(true);
    };
    const handleCloseModal = () => {
        setShowModal(false);
    };
    // done button reloading the page
    const handleCloseModalReload = () => {
        setShowModal(false);
        window.location.reload()
    };

    // form data to be sent to backend on adding the transaction
    const [formData, setFormData] = useState({
        transcation_type: "",
        bill_ref_number: "",
        overflow_amount: "",
        apartment: id,
        first_name: "",
        surname: "",
        transcation_amount: "",
        reconciled: true,
        transcation_time: "",
        phone_number: "",


    });
    // onchange functionality on adding the transaction
    const handleChange = (event) => {
        const { name, value } = event.target;
        setFormData((prevData) => ({
            ...prevData,
            [name]: value,
        }));
    };

    const handleChangeDate = (event) => {
        const { name, value } = event.target;

        // Check if the entered date is in the future
        const currentDate = new Date();
        const selectedDate = new Date(value);
        if (selectedDate > currentDate) {
            // Display an error message or handle the error as per your requirements
            toast.error('Error: Cannot select a future date');
            return;
        }

        // Check if the entered date is more than 6 months ago
        const sixMonthsAgo = new Date();
        sixMonthsAgo.setMonth(sixMonthsAgo.getMonth() - 6);
        if (selectedDate < sixMonthsAgo) {
            // Display an error message or handle the error as per your requirements
            toast.error('Error: Cannot select a date older than 6 months');
            return;
        }

        // Update the form data if the entered date is valid
        setFormData((prevData) => ({
            ...prevData,
            [name]: value,
        }));
    };

    // submit of adding a new transaction
    function handleSubmit(e) {

        // preventing from redirecting to other pages
        e.preventDefault();

        // get user details so that you can use it from the access tokens
        const accessToken = localStorage.getItem("authTokens");

        // decode the tokens so that you can get the user_id
        const decodedToken = jwt_decode(accessToken);
        const userId = decodedToken.user_id;

        // get the access token
        const parsedTokens = JSON.parse(accessToken);
        const access = parsedTokens.access;

        // header's access token
        const config = {
            headers: { Authorization: `Bearer ${access}` }
        }


        const data = {
            transcation_type: formData.transcation_type,
            bill_ref_number: formData.bill_ref_number,
            overflow_amount: formData.overflow_amount,
            transcation_amount: formData.transcation_amount,
            apartment: id,
            first_name: formData.first_name,
            surname: formData.surname,
            reconciled: true,
            transcation_time: formData.transcation_time,
            phone_number: formData.phone_number,

        };

        serverUrl.post(`/landlord/c2btranscation/`, data, config)
            .then((res) => {
                toast.success('Transaction Succesfully!')
            })
            .catch((error) => {
                toast.success('Error in Adding IUJTransaction!')

                console.log(error)
            })

    }

    // reconciliation
    const [showModalReconcile, setShowModalReconcile] = useState(false);
    const [selectedDefaulterId, setSelectedDefaulterId] = useState(null);
    const [selectedRecord, setSelectedRecord] = useState(null);
    const [selectedInvoices, setSelectedInvoices] = useState([]);

    const [selectedApartmentId, setSelectedApartmentId] = useState("");
    const [selectedUtilities, setSelectedUtilities] = useState([]);
    const [apartmentHouse, setApartmentHouse] = useState([]);

    const [houseSelectedId, setHouseSelectedId] = useState("");
    const [invoices, setInvoices] = useState([]);

    const [selectedCategory, setSelectedCategory] = useState([]);
    const [selectedUtility, setSelectedUtility] = useState("");

    const [formDataPayment, setFormDataPayment] = useState({
        apartment: "",
        house_number: "",
        category: '',
        utility_type: '',
        source: '',
        amount: '',
        paid_date: '',
        phone_number: ''
    });

    const formatTransactionDate = (transactionTime) => {
        if (!transactionTime || transactionTime.length < 8) return "";
        const year = transactionTime.substr(0, 4);
        const month = transactionTime.substr(4, 2);
        const day = transactionTime.substr(6, 2);
        return `${year}-${month}-${day}`;
    };

    const handleOpenModalReconcile = (record) => {
        setSelectedDefaulterId(record.id);
        setSelectedRecord(record);
        setShowModalReconcile(true);

        setFormDataPayment((prev) => ({
            ...prev,
            amount: record.transcation_amount || "",
            phone_number: record.phone_number || "",
            paid_date: formatTransactionDate(record.transcation_time)
        }));

        if (record.apartment) {
            handleApartmentSelect(record.apartment);
        } else if (record.apartment_name) {
            const nameMatch = landlordApartment.find(
                a => (a.name || "").toLowerCase() === String(record.apartment_name).toLowerCase()
            );
            if (nameMatch) {
                handleApartmentSelect(nameMatch.id);
            }
        }
    };

    const handleCloseModalReconcile = () => {
        setShowModalReconcile(false);
        setSelectedRecord(null);
        setSelectedDefaulterId(null);
        setSelectedInvoices([]);
        setSelectedCategory([]);
        setSelectedUtility("");
        setInvoices([]);
        setHouseSelectedId("");
        setSelectedApartmentId("");
        setFormDataPayment({
            apartment: "",
            house_number: "",
            category: '',
            utility_type: '',
            source: '',
            amount: '',
            paid_date: '',
            phone_number: ''
        });
    };

    async function handleApartmentSelect(selectedApartmentId) {
        setSelectedApartmentId(selectedApartmentId);

        try {
            const [housesRes, utilitiesRes] = await Promise.all([
                serverUrl.get(`/landlord/react-house-apartment-tenant/?apartment_id=${selectedApartmentId}`, config),
                serverUrl.get(`/landlord/expense/?apartment_id=${selectedApartmentId}`, config)
            ]);

            const occupiedHouses = housesRes.data.results.filter((house) => house.status === 'occupied');
            setApartmentHouse(occupiedHouses);
            setSelectedUtilities(utilitiesRes.data.results);
        } catch (error) {
            console.log("Error fetching apartment data:", error);
            toast.error("Failed to load apartment details");
        }
    }

    function handleHouseSelect(selectedHouseid) {
        setHouseSelectedId(selectedHouseid);

        if (selectedCategory && selectedCategory.length > 0) {
            setInvoices([]);
            selectedCategory.forEach(cat => {
                serverUrl.get(`/landlord/tenant-invoice/?house_id=${selectedHouseid}&reference=${cat}`, config)
                    .then((res) => {
                        const unpaidInvoices = res.data.results.filter(invoice => invoice.status !== "paid");
                        setInvoices(prev => {
                            const existingIds = new Set(prev.map(i => i.id));
                            const uniqueNew = unpaidInvoices.filter(i => !existingIds.has(i.id));
                            return [...prev, ...uniqueNew];
                        });
                    })
                    .catch((error) => {
                        console.log(error);
                    });
            });
        }
    }

    const handleCategorySelect = (categoryValue, isChecked) => {
        let updatedCategories;
        if (isChecked) {
            updatedCategories = [...selectedCategory, categoryValue];
        } else {
            updatedCategories = selectedCategory.filter(cat => cat !== categoryValue);
        }

        setSelectedCategory(updatedCategories);
        setSelectedUtility("");
        setInvoices([]);
        setSelectedInvoices([]);

        if (houseSelectedId && updatedCategories.length > 0) {
            updatedCategories.forEach((cat) => {
                serverUrl.get(`/landlord/tenant-invoice/?house_id=${houseSelectedId}&reference=${cat}`, config)
                    .then((res) => {
                        const unpaidInvoices = res.data.results.filter(invoice => invoice.status !== "paid");
                        setInvoices(prevInvoices => {
                            const existingIds = new Set(prevInvoices.map(inv => inv.id));
                            const uniqueNewInvoices = unpaidInvoices.filter(inv => !existingIds.has(inv.id));
                            return [...prevInvoices, ...uniqueNewInvoices];
                        });
                    })
                    .catch((error) => {
                        console.log(error);
                    });
            });
        }
    };

    function handleInvoiceToggle(invoice) {
        const invoiceId = invoice.id;

        setSelectedInvoices(prev => {
            if (prev.includes(invoiceId)) {
                return prev.filter(id => id !== invoiceId);
            } else {
                return [...prev, invoiceId];
            }
        });
    }

    function calculateTotalInvoiceAmount() {
        return selectedInvoices.reduce((total, invoiceId) => {
            const invoice = invoices.find(inv => inv.id === invoiceId);
            return total + (invoice ? parseFloat(invoice.amount) : 0);
        }, 0);
    }

    const handleChangePayment = (event) => {
        const { name, value } = event.target;
        setFormDataPayment((prevFormData) => ({
            ...prevFormData,
            [name]: value,
        }));
    };
    const exportCSV = () => {
        const csvData = [
            ['Paid Number', 'Paid By', 'Amount', 'Transaction Id', 'Date Paid', 'Failed Reason'],
            ...ctobTransactions.map((item) => [item.phone_number, item.first_name, item.transcation_amount, item.transcation_id, item.transcation_time, item.reason_for_failed_reconciliation]),
        ];
        const csvBlob = new Blob([csvData.join('\n')], { type: 'text/csv;charset=utf-8;' });
        saveAs(csvBlob, 'failed_reconciliation.csv');
    };

    const deleteTransactions = async (transactionIds) => {
        const uniqueTransactionIds = [...new Set(transactionIds)];
        if (uniqueTransactionIds.length === 0 || isDeleting) return;

        const confirmationMessage = uniqueTransactionIds.length === 1
            ? "Delete this unreconciled transaction? This cannot be undone."
            : `Delete ${uniqueTransactionIds.length} selected unreconciled transactions? This cannot be undone.`;
        if (!window.confirm(confirmationMessage)) return;

        setIsDeleting(true);
        try {
            const response = await serverUrl.delete(
                "/landlord/get-failed-reconciliation/",
                {
                    ...config,
                    data: { transaction_ids: uniqueTransactionIds },
                }
            );
            const deletedIds = response.data.deleted_ids || uniqueTransactionIds;
            const deletedIdSet = new Set(deletedIds);

            setCtobTransactions((currentTransactions) => (
                currentTransactions.filter((transaction) => !deletedIdSet.has(transaction.id))
            ));
            setSelectedTransactionIds((currentIds) => (
                currentIds.filter((transactionId) => !deletedIdSet.has(transactionId))
            ));

            const deletedFilteredCount = filteredTransactionIds.filter((transactionId) => (
                deletedIdSet.has(transactionId)
            )).length;
            const remainingFilteredCount = Math.max(0, filteredData.length - deletedFilteredCount);
            setCurrentPage((page) => Math.max(
                0,
                Math.min(page, Math.ceil(remainingFilteredCount / itemsPerPage) - 1)
            ));

            toast.success(
                deletedIds.length === 1
                    ? "Unreconciled transaction deleted."
                    : `${deletedIds.length} unreconciled transactions deleted.`
            );
        } catch (error) {
            console.log(error);
            toast.error(
                error.response?.data?.error || "Failed to delete the selected transaction(s)."
            );
        } finally {
            setIsDeleting(false);
        }
    };
    // save the data to the backend on the payment
    function handleSaveReconcile(e) {
        // prevent form from redirecting to another page
        e.preventDefault();
        if (!houseSelectedId) {
            toast.error("Please select a house");
            return;
        }

        if (selectedInvoices.length === 0) {
            toast.error("Please select at least one invoice");
            return;
        }

        const invoiceIdsParam = selectedInvoices.join(',');
        serverUrl
            .get(
                `/landlord/reconcile_transactions/?c2btransaction_id=${selectedDefaulterId}&house_id=${houseSelectedId}&invoice_ids=${invoiceIdsParam}`,
                config
            )
            .then(() => {
                toast.success("Successfully Reconciled Transaction!");
                window.location.reload();
            })
            .catch((error) => {
                console.log(error);
                toast.error("Failed to reconcile transaction");
            });

    }
    return (
        <>
             
            <div className='reconciliationReport'>
                <div className='tasks ' >
                    <h2 style={{ color: "#00cec9" }}>Failed Reconciliation</h2>

                    <div className='d-flex justify-content-between'>

                        <div>
                            <Button className='btn btn-success text-white me-3' onClick={exportCSV}> EXCEL <i className='bi bi-file-earmark-excel '></i></Button>
                            <Button
                                variant="danger"
                                className='text-white me-3'
                                disabled={selectedTransactionIds.length === 0 || isDeleting}
                                onClick={() => deleteTransactions(selectedTransactionIds)}
                            >
                                {isDeleting
                                    ? "Deleting..."
                                    : `Delete Selected (${selectedTransactionIds.length})`}
                            </Button>
                            <Button className='btn btn-sm text-white me-3 d-none ' onClick={handleOpenModal}>Add Transaction</Button>
                            {/* modal used in adding the transaction */}
                            <Modal show={showModal} onHide={handleCloseModal}>
                                <Modal.Header closeButton>
                                    <Modal.Title>Add A New Transaction</Modal.Title>
                                </Modal.Header>
                                <Modal.Body>
                                    <Form onSubmit={handleSubmit}>
                                        <div className="input-icons">
                                            <i className="fa fa-hashtag icon"></i>
                                            <input
                                                className="input-field"
                                                type="text"
                                                name="bill_ref_number"
                                                value={formData.bill_ref_number}
                                                onChange={handleChange}
                                                placeholder={"House Number"}
                                                required
                                            />
                                        </div>
                                        <div className="input-icons">
                                            <i className="fa fa-hashtag icon"></i>
                                            <input
                                                className="input-field"
                                                type="number"
                                                name="phone_number"
                                                value={formData.phone_number}
                                                onChange={handleChange}
                                                placeholder={"Phone Number"}
                                                required
                                            />
                                        </div>
                                        <div className="input-icons">
                                            <i className="fa fa-hashtag icon"></i>
                                            <input
                                                className="input-field"
                                                type="number"
                                                name="overflow_amount"
                                                value={formData.overflow_amount}
                                                onChange={handleChange}
                                                placeholder={"Overflow Amount"}
                                                required
                                            />
                                        </div>
                                        <div className="input-icons">
                                            <i className="fa fa-hashtag icon"></i>
                                            <input
                                                className="input-field"
                                                type="number"
                                                name="transcation_amount"
                                                value={formData.transcation_amount}
                                                onChange={handleChange}
                                                placeholder={"Paid Amount"}
                                                required
                                            />
                                        </div>
                                        <div className="input-icons">
                                            <i className="fa fa-hashtag icon"></i>
                                            <input
                                                className="input-field"
                                                type="date"
                                                name="transcation_time"
                                                value={formData.transcation_time}
                                                onChange={handleChangeDate}
                                                placeholder={"Date Paid"}
                                                required
                                            />
                                        </div>
                                        <div className="input-icons">
                                            <i className="fa fa-hashtag icon"></i>
                                            <input
                                                className="input-field"
                                                type="text"
                                                name="transcation_type"
                                                value={formData.transcation_type}
                                                onChange={handleChange}
                                                placeholder={"Transaction Type"}
                                                required
                                            />

                                        </div>
                                        <div className="input-icons">
                                            <i className="fa fa-hashtag icon"></i>
                                            <input
                                                className="input-field"
                                                type="text"
                                                name="first_name"
                                                value={formData.first_name}
                                                onChange={handleChange}
                                                placeholder={"First Name"}
                                                required
                                            />

                                        </div>
                                        <div className="input-icons">
                                            <i className="fa fa-hashtag icon"></i>
                                            <input
                                                className="input-field"
                                                type="text"
                                                name="surname"
                                                value={formData.surname}
                                                onChange={handleChange}
                                                placeholder={"Surname"}
                                                required
                                            />

                                        </div>


                                        <Button variant="primary" type="submit" className="nextBtn mt-3" >
                                            Save
                                        </Button>
                                    </Form>
                                </Modal.Body>
                                <Modal.Footer>

                                    <Button variant="success" onClick={handleCloseModalReload} >
                                        DONE
                                    </Button>
                                </Modal.Footer>
                            </Modal>
                            <Button className='btn btn-danger text-white d-none' >PDF <i className='bi bi-file-pdf-fill'></i></Button>
                        </div>
                        <Form className="searchBar">
                            <FormControl type="text" placeholder="Search" onChange={handleSearch} />
                        </Form>
                    </div>

                    <Table responsive className='table'>
                        <thead className="">
                            <tr>
                                <th>
                                    <label className="d-flex align-items-center gap-1 mb-0">
                                        <input
                                            type="checkbox"
                                            checked={areAllFilteredTransactionsSelected}
                                            onChange={handleSelectAll}
                                            disabled={filteredTransactionIds.length === 0 || isDeleting}
                                            aria-label="Select all filtered unreconciled transactions"
                                            title="Select all filtered transactions"
                                        />
                                        <span>Select all</span>
                                    </label>
                                </th>
                                <th onClick={() => handleSort("phone_number")}>Paid Number<i className='bi bi-chevron-expand'></i></th>
                                <th onClick={() => handleSort("first_name")}>Paid By<i className='bi bi-chevron-expand'></i></th>
                                <th onClick={() => handleSort("bill_ref_number")}>Unit<i className='bi bi-chevron-expand'></i></th>
                                <th onClick={() => handleSort("apartment_name")}>Apartment<i className='bi bi-chevron-expand'></i></th>
                                <th onClick={() => handleSort("transcation_amount")}>Amount<i className='bi bi-chevron-expand'></i></th>
                                <th onClick={() => handleSort("transcation_id")}>Transaction Id<i className='bi bi-chevron-expand'></i></th>
                                <th onClick={() => handleSort("transcation_time")}>Date Paid<i className='bi bi-chevron-expand'></i></th>
                                <th style={{ width: "30%" }} onClick={() => handleSort("reason_for_failed_reconciliation")}>Failed Reason<i className='bi bi-chevron-expand'></i></th>
                                <th>Actions</th>
                            </tr>
                        </thead>
                        <tbody>
                            {displayedItems.length === 0 ? (
                                <tr>
                                    <td colSpan="10" className="text-center text-muted py-4">
                                        No unreconciled transactions found.
                                    </td>
                                </tr>
                            ) : displayedItems.map((Defaulter) => (
                                <tr key={Defaulter.id}>
                                    <td>
                                        <input
                                            type="checkbox"
                                            checked={selectedTransactionIds.includes(Defaulter.id)}
                                            onChange={() => handleSelectTransaction(Defaulter.id)}
                                            disabled={isDeleting}
                                            aria-label={`Select transaction ${Defaulter.transcation_id}`}
                                        />
                                    </td>
                                    <td>{Defaulter.phone_number}</td>
                                    <td>{Defaulter.first_name}</td>
                                    <td>{Defaulter.bill_ref_number}</td>
                                    <td>{Defaulter.apartment_name || '-'}</td>
                                    <td>{Defaulter.transcation_amount}</td>
                                    <td>{Defaulter.transcation_id}</td>
                                    <td>{Defaulter.transcation_time.substr(6, 2)}-{Defaulter.transcation_time.substr(4, 2)}-{Defaulter.transcation_time.substr(0, 4)}</td>
                                    <td>{Defaulter.reason_for_failed_reconciliation}</td>
                                    <td>
                                        <div className="d-flex gap-2">
                                            <Button
                                                size="sm"
                                                variant="success"
                                                disabled={isDeleting}
                                                onClick={() => handleOpenModalReconcile(Defaulter)}
                                            >
                                                Reconcile
                                            </Button>
                                            <Button
                                                size="sm"
                                                variant="outline-danger"
                                                disabled={isDeleting}
                                                onClick={() => deleteTransactions([Defaulter.id])}
                                            >
                                                Delete
                                            </Button>
                                        </div>
                                    </td>
                                </tr>
                            ))}
                        </tbody>
                    </Table>

                    <ReconcileFailedPaymentModal
                        showModalPayment={showModalReconcile}
                        selectedRecord={selectedRecord}
                        formDataPayment={formDataPayment}
                        landlordApartment={landlordApartment}
                        apartmentHouse={apartmentHouse}
                        selectedApartmentId={selectedApartmentId}
                        houseSelectedId={houseSelectedId}
                        selectedCategory={selectedCategory}
                        selectedUtilities={selectedUtilities}
                        selectedUtility={selectedUtility}
                        invoices={invoices}
                        selectedInvoices={selectedInvoices}
                        handleCloseModalPayment={handleCloseModalReconcile}
                        handleSavePayment={handleSaveReconcile}
                        handleChangePayment={handleChangePayment}
                        handleApartmentSelect={handleApartmentSelect}
                        handleHouseSelect={handleHouseSelect}
                        handleCategorySelect={handleCategorySelect}
                        setSelectedUtility={setSelectedUtility}
                        handleInvoiceToggle={handleInvoiceToggle}
                        calculateTotalInvoiceAmount={calculateTotalInvoiceAmount}
                    />
                    {/* get the display of the items 5 per page */}
                    <div className="pagination">
                        <button onClick={handlePrevPage} disabled={currentPage === 0}>
                            &lt;
                        </button>
                        <span>{filteredData.length === 0 ? "0 of 0" : `${startIndex + 1}-${endIndex} of ${filteredData.length}`}</span>
                        <button onClick={handleNextPage} disabled={totalPages === 0 || currentPage >= totalPages - 1}>
                            &gt;
                        </button>

                    </div>
                </div>
            </div>
        </>
    )
}

export default FailedReconciliation
